jQuery(document).ready(function($) {

  // carousel left and right
  var carouselRightSettings = {
    cellSelector: '.carousel-cell',
    cellAlign: 'center',
    pageDots: false,
    prevNextButtons: false,
    draggable: false,
    autoPlay: 0,
    fade: true,
    adaptiveHeight: true
  }

  if (Foundation.MediaQuery.current == 'small') {
    carouselRightSettings.selectedAttraction = 0
    carouselRightSettings.friction = 100
  }

  var $carouselRight = $('.carousel-right').flickity(carouselRightSettings)


  var carouselLeftSettings = {
    cellSelector: '.carousel-cell',
    contain: true,
    pageDots: $('.carousel-left .carousel-cell').length > 1,
    prevNextButtons: false,
    percentPosition: false,
    autoPlay: 10000,
    imagesLoaded: true,
    fade: true,
    setGallerySize: false,
    on: {
      change: function (index) {
        $carouselRight.flickity('select', index)
      }
    }
  }

  if (Foundation.MediaQuery.current == 'small') {
    carouselLeftSettings.selectedAttraction = 0
    carouselLeftSettings.friction = 100
  }

  var $carouselLeft = $('.carousel-left').flickity(carouselLeftSettings)

  $('.carousels .carousel-next').on('click', function() {
    $carouselLeft.flickity('stopPlayer').flickity('next', true).flickity('playPlayer')
  })

  $('.carousels .carousel-previous').on('click', function() {
    $carouselLeft.flickity('stopPlayer').flickity('previous', true).flickity('playPlayer')
  })

  // bottom carousel
  if ($('.carousel-bottom')) {
    var $carouselBottom = $('.carousel-bottom').flickity({
      cellSelector: '.carousel-cell',
      contain: true,
      pageDots: $('.carousel-bottom .carousel-cell').length > 1,
      prevNextButtons: false,
      percentPosition: false,
      autoPlay: 4000,
      imagesLoaded: true,
      fade: true,
      setGallerySize: false
    })

    $('.carousel-bottom-container .carousel-next').on('click', function() {
      $carouselBottom.flickity('stopPlayer').flickity('next', true).flickity('playPlayer')
    })

    $('.carousel-bottom-container .carousel-previous').on('click', function() {
      $carouselBottom.flickity('stopPlayer').flickity('previous', true).flickity('playPlayer')
    })
  }

  // venues scroll to
  if ($('.home').length > 0) {
    $('a[href="/#places-partners"]').on('click', function(e) {
      e.preventDefault();
      $('html, body').animate({ scrollTop: $('.places-partners').offset().top  }, 750)
    })

    if (window.location.hash == '#places-partners') {
      setTimeout(function() {
        $('a[href="/#places-partners"]').trigger('click')
      }, 750)
    }
  }

  // event types
  $('.event-types .text').on('click', function(e) {
    var $a = $(this).find('a')
    if ($a.length > 0) {
      window.location = $a.attr('href')
      e.preventDefault()
    }
  })

})
